
export class ChangePassword{

    currentPassword: string;
    newPassword: string;
    newPasswordConfirmation: string;
}


// WEBPACK FOOTER //
// D:/a/1/s/src/app/Home/model/ChangePassword.ts